import React from "react";
import dayjs from "dayjs";
import { PdfHeader } from "../../../../components";
import { formatAmount, formatPhoneNumber } from "../../../../utils/appUtils";
import "./style.scss";

const UnpaidLawyerTransactionReport = ({ data, searchFilter, totalElements, totalBalanceAmount }) => {
    const renderData = data && data?.length ? data : [];
    const chunkData = (arr) => {
        if (!arr || !arr.length) return [];
        const pages = [];
        for (let i = 0; i < arr.length; i += 3) {
            pages.push(arr.slice(i, i + 3));
        }
        return pages;
    };

    const pages = chunkData(renderData);

    return (
        <div className="transaction-report">
            <div className="report-container" style={{ padding: 0, margin: 0 }}>
                {pages.map((pageData, pageIdx) => (
                    <div className={`report-page ${pageIdx < pages.length - 1 ? 'page-break' : ''}`} key={pageIdx}>
                        {pageIdx === 0 && (
                            <>
                                <PdfHeader pdfName="Advocate Unpaid Transaction Report" searchFilter={searchFilter} />
                                <div className="report-generation-time-header" style={{ padding: "0 10px 10px", textAlign: "right", color: "#667085", fontSize: "12px" }}>
                                    Generated on {dayjs().format("DD-MM-YYYY HH:mm")}
                                </div>
                            </>
                        )}
                        <div className="report-header-row">
                            <div className="header-cell col-sno">SNo.</div>
                            <div className="header-cell col-name-id">Advocate Name / ID</div>
                            <div className="header-cell col-contact">Contact Info</div>
                            <div className="header-cell col-holder">Account Holder Name</div>
                            <div className="header-cell col-bank">Account No / Bank name</div>
                            <div className="header-cell col-ifsc">IFSC</div>
                            <div className="header-cell col-unpaid">Unpaid Cons.</div>
                        </div>
                        <div className="report-cards-container">
                            {pageData.map((detail, index) => {
                                const globalIndex = pageIdx * 3 + index;
                                const unpaidConsultationCount = detail?.consultationIds?.length || 0;
                                const lawyerName = detail?.lawyerName || "Nil";
                                const accountHolderName = detail?.bankDetails?.accountHolderName || "Nil";
                                const accountNumber = detail?.bankDetails?.decryptAccountNumber || "Nil";
                                const ifscCode = detail?.bankDetails?.ifsc || "Nil";
                                const bankName = detail?.bankDetails?.bankName || "Nil";
                                const consFromApi = detail?.consultationResponses || [];
                                const consultations = consFromApi.map(consultation => {
                                    const addOnList = consultation?.consultationPaymentDetails?.addOnList || [];
                                    const addOns = addOnList.map(addOnItem => addOnItem?.addOn).filter(Boolean);
                                    const addOnFee = addOnList.reduce((sum, addOnItem) => sum + (Number(addOnItem?.amountWithOutGst) || 0), 0);
                                    const fees = consultation?.lawyerFeeAmount ?? 0;
                                    return {
                                        consultationNo: consultation?.consultationNo || "Nil",
                                        consultationDate: consultation?.consultationDate ? dayjs(consultation?.consultationDate).format("DD-MM-YYYY") : "Nil",
                                        consultationTime: consultation?.consultationTime || 0,
                                        addOns,
                                        addOnFee,
                                        fees
                                    };
                                });
                                const totalAddOnFee = consultations.reduce((total, consultation) => total + (Number(consultation?.addOnFee) || 0), 0);
                                const totalAmount = detail?.totalAmount ?? 0;

                                return (
                                    <div className="advocate-card" key={detail?.lawyerId || globalIndex}>
                                        <div className="card-info-row">
                                            <div className="card-cell col-sno">
                                                <span className="sno-badge">{globalIndex + 1}</span>
                                            </div>
                                            <div className="card-cell col-name-id">
                                                <div className="name">{lawyerName}</div>
                                                <div className="id">{detail?.lawyerNo || "Nil"}</div>
                                            </div>
                                            <div className="card-cell col-contact">
                                                <div className="phone">{detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}</div>
                                                <div className="email">{detail?.email || "Nil"}</div>
                                            </div>
                                            <div className="card-cell col-holder">
                                                <div className="holder-name">{accountHolderName}</div>
                                            </div>
                                            <div className="card-cell col-bank">
                                                <div className="account">{accountNumber}</div>
                                                <div className="bank-name">{bankName}</div>
                                            </div>
                                            <div className="card-cell col-ifsc">{ifscCode}</div>
                                            <div className="card-cell col-unpaid">{unpaidConsultationCount}</div>
                                        </div>
                                        <div className="card-table-container">
                                            <table className="inner-consultation-table">
                                                <thead>
                                                    <tr>
                                                        <th className="col-date">Cons. Date</th>
                                                        <th className="col-id">Cons. ID</th>
                                                        <th className="col-min">Cons. Min</th>
                                                        <th className="col-desc">Add on (Description)</th>
                                                        <th className="col-fee text-right">Add on Fee (₹)</th>
                                                        <th className="col-fee text-right">Advocate Fee (₹)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {consultations.map((consultation, consultationIndex) => (
                                                        <tr key={consultationIndex}>
                                                            <td className="col-date">{consultation?.consultationDate || "Nil"}</td>
                                                            <td className="col-id">{consultation?.consultationNo || "Nil"}</td>
                                                            <td className="col-min">{consultation?.consultationTime ? `${consultation?.consultationTime} Min` : "Nil"}</td>
                                                            <td className="col-desc">{(consultation?.addOns || []).join(", ") || "Nil"}</td>
                                                            <td className="col-fee text-right">
                                                                {consultation?.addOnFee === 0 ? `₹ 0` : (consultation?.addOnFee ? `₹ ${formatAmount(consultation?.addOnFee)}` : "Nil")}
                                                            </td>
                                                            <td className="col-fee text-right">
                                                                {consultation?.fees === 0 ? `₹ 0` : (consultation?.fees && consultation?.fees !== "Nil" ? `₹ ${formatAmount(consultation?.fees)}` : "Nil")}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="card-summary-row">
                                            <div className="summary-section section-consultations">
                                                <div className="icon-container">
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#005D60" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                                        <circle cx="9" cy="7" r="4" />
                                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                    </svg>
                                                </div>
                                                <div className="text-stack">
                                                    <span className="label">Total Consultations</span>
                                                    <span className="value">{unpaidConsultationCount}</span>
                                                </div>
                                            </div>
                                            <div className="summary-section section-addon">
                                                <div className="text-stack">
                                                    <span className="label">Total Add on Fee</span>
                                                    <span className="value">₹ {formatAmount(totalAddOnFee)}</span>
                                                </div>
                                            </div>
                                            <div className="summary-section section-total">
                                                <div className="text-stack">
                                                    <span className="label">Total Amount</span>
                                                    <span className="value">₹ {formatAmount(totalAmount)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UnpaidLawyerTransactionReport;
